import { checkHttpStatusAuthCheck } from '../../../../../../../actions/utilAction';
import { actionCreator, generalSettingsActionTypes, checkHttpStatus, jsonApiHeader, POST_PATIENT_GENERAL_SETTINGS_API, showErrorMessage, showSuccessMessage, GET_PATIENT_GENERAL_SETTINGS_API, GET_MASTERDATABYNAME } from '../constants/ApiConstants';


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(generalSettingsActionTypes.get_masterData.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(generalSettingsActionTypes.get_masterData.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const getPatientGeneralSettingsDetail = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(generalSettingsActionTypes.get_patientGeneralSettings.REQUEST));
    fetch(`${GET_PATIENT_GENERAL_SETTINGS_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(generalSettingsActionTypes.get_patientGeneralSettings.SUCCESS, response));
        } else {
          dispatch(actionCreator(generalSettingsActionTypes.get_patientGeneralSettings.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_patientGeneralSettings', error);
      });
  };
};

export const savePatientGeneralSettings = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(generalSettingsActionTypes.save_patientGeneralSettings.REQUEST));
    fetch(`${POST_PATIENT_GENERAL_SETTINGS_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(generalSettingsActionTypes.save_patientGeneralSettings.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(generalSettingsActionTypes.save_patientGeneralSettings.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error save_patientGeneralSettings', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/generalSettings/actions/GeneralSettingsActions.js